import request from '../utils/request'

export function adminRegister(data) {
  return request({
    url: '/api/admin/auth/register',
    method: 'post',
    data
  })
}

export function adminLogin(data) {
  return request({
    url: '/api/admin/auth/login',
    method: 'post',
    data
  })
}

export function getAdminMe() {
  return request({
    url: '/api/admin/auth/me',
    method: 'get'
  })
}

export function changeAdminPassword(data) {
  return request({
    url: '/api/admin/auth/change-password',
    method: 'post',
    data
  })
}
